export enum EFormPaymentType {
  card,
  konbini,
}
